import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu"];
  static values = {
    profileUrl: String,
    tipUrl: String
  };

  connect() {
    this.boundClose = this.closeIfOutside.bind(this);
    this.boundEscape = this.closeOnEscape.bind(this);
  }

  disconnect() {
    this.hide();
  }

  open(event) {
    event.preventDefault();

    if (!this.hasMenuTarget) return;

    this.menuTarget.hidden = false;
    this.menuTarget.style.left = `${event.clientX + 10}px`;
    this.menuTarget.style.top = `${event.clientY + 10}px`;

    window.addEventListener("click", this.boundClose);
    window.addEventListener("contextmenu", this.boundClose);
    window.addEventListener("keydown", this.boundEscape);
  }

  async copyProfile(event) {
    event.preventDefault();

    if (!this.profileUrlValue) return;

    try {
      await navigator.clipboard.writeText(this.profileUrlValue);
    } catch (_error) {
      window.prompt("Copy profile url", this.profileUrlValue);
    }

    this.hide();
  }

  sendMaza(event) {
    event.preventDefault();
    if (!this.tipUrlValue) return;

    this.hide();
    window.location.href = this.tipUrlValue;
  }

  closeIfOutside(event) {
    if (this.element.contains(event.target) || this.menuTarget.contains(event.target)) return;
    this.hide();
  }

  closeOnEscape(event) {
    if (event.key === "Escape") this.hide();
  }

  hide() {
    if (!this.hasMenuTarget) return;

    this.menuTarget.hidden = true;
    window.removeEventListener("click", this.boundClose);
    window.removeEventListener("contextmenu", this.boundClose);
    window.removeEventListener("keydown", this.boundEscape);
  }
}
